

















import { Component, Prop, Vue } from "vue-property-decorator";
import { IFilmCategory as ICat } from "@/@types/cinema/film-category";

@Component({})
export default class CinemaCategoryTabs extends Vue {
  @Prop({ type: Array, default: () => [] }) categorys!: Array<ICat>;
  @Prop({ type: String, default: "" }) category_id!: string;

  tabIndex = 1;

  get visibleCategorys(): Array<ICat> {
    return this.categorys.filter((c) => c.show);
  }
}
